// src/utils/scrollTopOnMain.js
(function () {
  // SSR/테스트 보호
  if (typeof window === 'undefined') return;

  // 중복 설치 방지 (한 번만 패치)
  if (window.__scrollTopOnMainInstalled) return;
  window.__scrollTopOnMainInstalled = true;

  function goTopIfMain() {
    // 필요하면 startsWith('/main')로
    if (window.location.pathname === '/main') {
      if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'manual';
      }
      // 렌더 후 스크롤
      window.requestAnimationFrame(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      });
    }
  }

  // pushState/replaceState 패치하여 커스텀 이벤트 발생
  ['pushState', 'replaceState'].forEach((type) => {
    const orig = window.history[type];
    if (typeof orig !== 'function') return;

    // 원본 this=history 보장
    window.history[type] = function patchedHistoryMethod(...args) {
      const ret = orig.apply(window.history, args);
      // 라우트 변경 통지
      window.dispatchEvent(new Event('locationchange'));
      return ret;
    };
  });

  // 뒤로/앞으로
  window.addEventListener('popstate', () => {
    window.dispatchEvent(new Event('locationchange'));
  }, { passive: true });

  // 라우트 변화 처리
  window.addEventListener('locationchange', goTopIfMain, { passive: true });

  // 초기 진입 1회
  goTopIfMain();
})();
